import { getOptions } from "./options";
import { system } from "../redux/reducers";

/**
 * 获取系统发布信息
 */
export function getSystemRelease() {
  return { ...system.state.release, }
}

/**
 * 获取系统发布上下文
 */
export function getSystemReleaseContext() {
  const { release } = system.state;
  return release && release.context ? release.context : "";
}

/**
 * 获取系统发布路径
 * @param {string} path 路径
 */
export function getSystemReleasePath(path) {
  const releseContext = getSystemReleaseContext();
  path = releseContext ? `/${releseContext}${path}` : path;
  const { context } = getOptions();
  path = context ? `${context}${path}` : path;
  return path;
}
